import css from 'styled-jsx/css';

const styles = css`:root {
    /* @TODO get a hold of/unify these colors...
       tell design to stop giving us a new color palatte
       with each new design...
    */

    /* New II Design Pattern - Introduced 11-12-2019 */
    /* TODO: --grey-800 is the color for primary text and should be used throughout the entire application */
}
:root {

    /* Margin and padding should be in multiples of 8 (i.e.---8, 16, 24) */

    /* New II Design Pattern - Introduced 11-12-2019 */
}
:root {

    /* New II Design Pattern - Introduced 11-12-2019 */
}
/* @import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css'; */
nav {
    position: absolute;
    bottom: 0;
    right: 0;
    color: #086ea1;
    margin: calc(24px / 2);
    width: -webkit-max-content;
    width: max-content;
}
a {
    display: inline-block;
    width: 32px;
    height: 32px;
    overflow: hidden;
    border-radius: 50px;
    border: 1px solid #b3b3b3;
    text-indent: 100%;
    vertical-align: middle;
    margin: calc(24px / 2);
    cursor: pointer;
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg width='7' height='12' viewBox='0 0 7 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L6 6L1 11' stroke='%234F4F4F' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: center;
}
a.prev {
    -webkit-transform: scaleX(-1);
            transform: scaleX(-1);
}
a.disabled {
    cursor: not-allowed;
    opacity: 0.3;
}
`;

export default styles;